import Head from "next/head";
import { wrapper } from "@/redux/Store";

import MedicalDeclaimer from "@/containers/StaticPages/Medical";
import { renderMetaData } from "@/utils";
const MedicalDeclaimerPage = () => {
  const metaData = {
    title: "Shyft waiver and dislaimer",
    description: "Shyft waiver and dislaimer",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <MedicalDeclaimer />
      </main>
    </>
  );
};

export default MedicalDeclaimerPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});

// Shyft waiver and dislaimer
